export const EVALUATION_DAYLY_AVERAGE_REQUEST = "EVALUATION_DAYLY_AVERAGE_REQUEST";
export const EVALUATION_DAYLY_AVERAGE_REQUEST_SUCCEEDED = "EVALUATION_DAYLY_AVERAGE_REQUEST_SUCCEEDED";
export const EVALUATION_DAYLY_AVERAGE_REQUEST_FAILED = "EVALUATION_DAYLY_AVERAGE_REQUEST";
export const EVALUATION_MONTHLY_AVERAGE_REQUEST = "EVALUATION_MONTHLY_AVERAGE_REQUEST";
export const EVALUATION_MONTHLY_AVERAGE_REQUEST_SUCCEEDED = "EVALUATION_MONTHLY_AVERAGE_REQUEST_SUCCEEDED";
export const EVALUATION_MONTHLY_AVERAGE_REQUEST_FAILED = "EVALUATION_MONTHLY_AVERAGE_REQUEST_FAILED";
